import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { TimePeriod, LeaderboardRow } from '../types';

export function useLeaderboard(period: TimePeriod) {
  return useQuery({
    queryKey: ['leaderboard', period],
    queryFn: async (): Promise<LeaderboardRow[]> =>
      pb.send<LeaderboardRow[]>(`/api/progress/leaderboard?period=${period}`, {
        method: 'GET',
      }),
    staleTime: 60_000,
  });
}
